import { useEffect } from 'react';
import { ApolloError } from '@apollo/client';
import { logException } from 'App/logging';

/**
 * Logs a homepage section's query failure exactly once per failure.
 *
 * In an effect, not the render path: a render-body call would re-fire for
 * every re-render while `error` is truthy.
 *
 * `data` gates the log because a background refetch failure over cached data
 * leaves `data` populated, and that case is silent elsewhere in the section.
 */
export const useSectionErrorLogging = (
  error: ApolloError | undefined,
  data: unknown,
  homeSection: string,
) =>
  useEffect(() => {
    if (error && !data) {
      logException(error, { tags: { homeSection } });
    }
  }, [error, data, homeSection]);
